// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"362":"354e6f7b","795":"a2269720","930":"7686ea8a"}[chunkId] + ".css";
};